import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './components/login/login.component';
import { MaterialModule } from '../demo-material-module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginService } from './services/login.service';
import { UserLoginComponent } from './components/user-login/user-login.component';


@NgModule({
  declarations: [LoginComponent, UserLoginComponent ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports: [UserLoginComponent],
  providers: [
    LoginService
  ]
})
export class AuthModule {
}
